/* SS - the strip under the buy button (snippets/ss-family-strip.liquid): add a product to the cart from a card.
   Kristoffer/Claude 14.09.2026; 17.09.2026 v2 (variant A): the size select starts empty («Velg størrelse») - «Legg til»
   without a size marks the select red and opens it; the label follows the chosen size; dots under the scroll row.
   Cart flow as the upsell cards in the cart drawer (sections/tcc-cart-drawer.liquid): POST /cart/add.js, then the
   "gOpenCart" event - the drawer re-fetches its sections and opens. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ss-fam__add');
    if (!btn) return;
    var card = btn.closest('[data-ss-fam-card]');
    var sel = card && card.querySelector('.ss-fam__size');
    var vid = btn.getAttribute('data-vid');
    if (sel) {
      if (!sel.value) {
        var wrap = sel.closest('.ss-fam__sizewrap') || sel;
        wrap.classList.add('is-missing');
        sel.focus();
        if (typeof sel.showPicker === 'function') { try { sel.showPicker(); } catch (err) {} }
        return;
      }
      vid = sel.value;
    }
    btn.disabled = true;
    if (card) card.classList.add('is-adding');
    /* Claude 25.10.2026 - hidden line item property so the order shows where the line came from: pdp<n> = card n in the
       strip under the buy button, look = the «Shop the look» sheet. Read back by scripts/cart-upsells/. */
    var stripEl = card && card.closest('[data-ss-fam-strip]');
    var source = stripEl ? 'pdp' + (Array.prototype.indexOf.call(stripEl.children, card) + 1) : 'look';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1, properties: { _upsell: source } })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (x) {
        if (!x.ok) console.error('ss-family: add failed', x.d && (x.d.description || x.d.message));
        document.dispatchEvent(new Event('gOpenCart'));
      })
      .catch(function (err) {
        console.error('ss-family: add failed', err);
        document.dispatchEvent(new Event('gOpenCart'));
      })
      .then(function () {
        btn.disabled = false;
        if (card) card.classList.remove('is-adding');
      });
  });
  document.addEventListener('change', function (e) {
    var s = e.target; if (!s.classList || !s.classList.contains('ss-fam__size')) return;
    var wrap = s.closest('.ss-fam__sizewrap'); if (!wrap) return;
    wrap.classList.remove('is-missing');
    var lab = wrap.querySelector('.ss-fam__sizelabel'); if (!lab) return;
    if (s.value) {
      lab.textContent = s.options[s.selectedIndex].textContent.replace(/\s*\([^)]*\)\s*$/, ''); /* «10-12 år (146/152)» -> «10-12 år» */
      lab.classList.remove('is-empty');
    }
  });
  /* dots under a scroll row: one per "page" of visible cards */
  function dots(fam) {
    var strip = fam.querySelector('[data-ss-fam-strip]'), box = fam.querySelector('[data-ss-fam-dots]');
    if (!strip || !box) return;
    function build() {
      var pages = Math.max(1, Math.ceil((strip.scrollWidth - 1) / strip.clientWidth));
      box.hidden = pages <= 1; /* everything fits (wide desktop column): nothing to slide, no dots */
      if (box.children.length !== pages) { box.innerHTML = ''; for (var i = 0; i < pages; i++) box.appendChild(document.createElement('i')); }
      /* 18.09: aktiv prikk = andel av total scrollavstand, ikke antall skjermbredder - ellers viste enden prikk 2 av 3 */
      var maxScroll = Math.max(1, strip.scrollWidth - strip.clientWidth);
      var on = Math.min(pages - 1, Math.round((strip.scrollLeft / maxScroll) * (pages - 1)));
      for (var k = 0; k < box.children.length; k++) box.children[k].classList.toggle('is-on', k === on);
    }
    /* 21.09: arrows (desktop only via CSS) - one "page" of cards per click, hidden at either end */
    var arrows = fam.querySelectorAll('[data-ss-fam-arr]');
    function syncArrows() {
      var maxScroll = strip.scrollWidth - strip.clientWidth;
      for (var a = 0; a < arrows.length; a++) {
        var dir = +arrows[a].getAttribute('data-ss-fam-arr');
        arrows[a].hidden = maxScroll <= 2 || (dir < 0 ? strip.scrollLeft <= 2 : strip.scrollLeft >= maxScroll - 2);
      }
    }
    for (var a = 0; a < arrows.length; a++) {
      arrows[a].addEventListener('click', function () {
        var card = strip.firstElementChild, step = card ? card.getBoundingClientRect().width + 12 : 162;
        var per = Math.max(1, Math.floor((strip.clientWidth + 12) / step));
        strip.scrollBy({ left: +this.getAttribute('data-ss-fam-arr') * per * step, behavior: 'smooth' });
      });
    }
    function all() { build(); syncArrows(); }
    all();
    strip.addEventListener('scroll', all, { passive: true });
    window.addEventListener('resize', all);
  }
  function init() { document.querySelectorAll('.ss-fam--scroll').forEach(dots); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
